package api.dataclasses.outbound

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class OutboundOrderline(
    @SerialName("Adviesprijs") val suggestedRetailPrice: Double,
    @SerialName("Artikel") val article: String,
    @SerialName("Artikelgroep") val articleCategory: String,
    @SerialName("Artikelnummer") val articleNumber: String,
    @SerialName("Bericht") val message: String,
    @SerialName("Gepickt aantal") val pickedAmount: Double,
    @SerialName("Ingepakt aantal") val packedAmount: Double,
    @SerialName("Kleur omschrijving") val colorDescription: String,
    @SerialName("Lengtemaat") val lengthSize: String,
    @SerialName("Maatcode") val sizeCode: String,
    @SerialName("Magazijncode") val warehouseCode: String,
    @SerialName("Omschrijving") val description: String,
    @SerialName("Order aantal") val orderAmount: Double,
    @SerialName("Pickopdracht") val outboundOrder: Int,
    @SerialName("Regelnummer") val recordId: Int,
    @SerialName("Regelnummer_extern") val externalRecordId: Int,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Te picken aantal") val amountToPick: Double,
    @SerialName("Variantcode") val variantCode: String
)